import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptAll,
  rejectAll,
  saveCustomPreferences,
  hideConsentBanner,
} from "./cookieConsentSlice";
import "./CookieConsentBanner.scss";
import cookiePolicyDoc from "./Politika-o-kolacicima.pdf";

const CookieConsentBanner = () => {
  const dispatch = useDispatch();
  const { showBanner } = useSelector((state) => state.cookieConsent);
  const [showSettings, setShowSettings] = useState(false);
  const [localPreferences, setLocalPreferences] = useState({
    analytics: false,
    advertisement: false,
  });
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  if (!showBanner) return null;

  const handleAcceptAll = () => {
    dispatch(acceptAll());
  };

  const handleRejectAll = () => {
    dispatch(rejectAll());
  };

  const handleShowSettings = () => {
    setShowSettings(true);
  };

  const handleClose = () => {
    dispatch(hideConsentBanner());
  };

  const handleToggle = (key) => {
    setLocalPreferences((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSavePreferences = () => {
    dispatch(
      saveCustomPreferences({
        necessary: true,
        analytics: localPreferences.analytics,
        advertisement: localPreferences.advertisement,
      }),
    );
  };

  const toggleAccordion = (key) => {
    setExpandedAccordion((prev) => (prev === key ? null : key));
  };

  const categories = [
    {
      key: "necessary",
      name: "Funkcionalno",
      alwaysActive: true,
      description:
        "Tehničko skladištenje ili pristup je striktno neophodan za legitimnu svrhu omogućavanja korišćenja određene usluge koju izričito zahteva pretplatnik ili korisnik, ili u jedinu svrhu obavljanja prenosa komunikacije preko elektronske komunikacione mreže.",
    },
    {
      key: "analytics",
      name: "Statistika",
      alwaysActive: false,
      description:
        "Tehničko skladište ili pristup koji se koristi isključivo u statističke svrhe.",
    },
    {
      key: "advertisement",
      name: "Marketing",
      alwaysActive: false,
      description:
        "Tehničko skladište ili pristup su potrebni za kreiranje korisničkih profila za slanje reklama ili za praćenje korisnika na veb lokaciji ili na nekoliko veb lokacija u slične marketinške svrhe.",
    },
  ];

  return (
    <div className="cookie-overlay">
      <div className="cookie-consent">
        <button
          className="cookie-consent__close"
          onClick={handleClose}
          aria-label="Zatvori"
        >
          &times;
        </button>

        <h2 className="cookie-consent__title">Upravljajte saglasnostima</h2>

        <p className="cookie-consent__text">
          Da bismo pružili najbolje iskustvo, koristimo tehnologije poput
          kolačića za čuvanje i/ili pristup informacijama o uređaju. Saglasnost
          sa ovim tehnologijama će nam omogućiti da obrađujemo podatke kao što
          su ponašanje pri pregledanju ili jedinstveni ID-ovi na ovoj veb
          lokaciji. Nepristanak ili povlačenje saglasnosti može negativno
          uticati na određene karakteristike i funkcije.
        </p>

        {showSettings && (
          <div className="cookie-consent__categories">
            {categories.map((cat) => (
              <div key={cat.key} className="cookie-category">
                <div className="cookie-category__header">
                  <span className="cookie-category__name">{cat.name}</span>
                  <div className="cookie-category__controls">
                    {cat.alwaysActive ? (
                      <span className="cookie-category__always-active">
                        Uvijek aktivan
                      </span>
                    ) : (
                      <label className="cookie-toggle">
                        <input
                          type="checkbox"
                          checked={localPreferences[cat.key]}
                          onChange={() => handleToggle(cat.key)}
                        />
                        <span className="cookie-toggle__slider"></span>
                      </label>
                    )}
                    <button
                      className={`cookie-category__chevron ${expandedAccordion === cat.key ? "cookie-category__chevron--open" : ""}`}
                      onClick={() => toggleAccordion(cat.key)}
                      aria-label={`Proširi ${cat.name}`}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                {expandedAccordion === cat.key && (
                  <div className="cookie-category__body">
                    <p>{cat.description}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="cookie-consent__actions">
          <button
            className="cookie-consent__btn cookie-consent__btn--outline"
            onClick={handleAcceptAll}
          >
            Prihvati
          </button>
          <button
            className="cookie-consent__btn cookie-consent__btn--outline"
            onClick={handleRejectAll}
          >
            Odbij
          </button>
          {!showSettings ? (
            <button
              className="cookie-consent__btn cookie-consent__btn--outline"
              onClick={handleShowSettings}
            >
              Prikaži podešavanja
            </button>
          ) : (
            <button
              className="cookie-consent__btn cookie-consent__btn--outline"
              onClick={handleSavePreferences}
            >
              Sačuvaj preference
            </button>
          )}
        </div>

        <div className="cookie-consent__links">
          <a
            href={cookiePolicyDoc}
            target="_blank"
            rel="noopener noreferrer"
          >
            Politika kolačića
          </a>
          <a
            href="https://www.partner.ba/wp-content/uploads/2025/10/Politika_privatnosti_Partner.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Izjava o privatnosti
          </a>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
